const carousel = (function(){

    function _carousel(){

            function carouselReuse(
                clase,
                items = 4,
                loop = false,
                margin = 10,
                nav = false, imgL = "../static/img-estatica/png/left__circle.png", imgR = "../static/img-estatica/png/right__circle.png",
                autoplay = false,
                autoplayTimeout = 0,
                dots = false,
                mobile = 1,
                ipadPequeña = 2,
                ipadGrande = 3,
                desktop = 4
                ){
                clase.owlCarousel({
                    items : items, //NUMERO DE ITEMS
                    loop: loop, // HACE AL CAROUSEL INFINITO
                    margin: margin, //MARGEN ENTRE ELEMENTOS
                    nav: nav, //AGREGAR NAVEGACIÓN(FLECHAS)
                    autoplay: autoplay, //AGREGAR AUTOPLAY
                    autoplayTimeout: autoplayTimeout, //TIEMPO DEL AUTOPLAY
                    dots: dots, //PARA OCULTAR O MOSTRAR LOS DOTS
                    // animateOut: 'fadeOut', //ANIMACION
                    // touchDrag: false, //DESHABILITAR DRAG
                    // mouseDrag: false, //DESHABILITAR DRAG
                    responsive: { //RESPONSIVE
                        0:{
                            items: mobile
                        },
                        576:{
                            items: ipadPequeña
                        },
                        992:{
                            items: ipadGrande
                        },
                        1440:{
                            items: desktop
                        }
                    }
                });
        
                //CREAR NAV Y DOTS
                var objectToArrray = Object.values(clase);
        
                if(nav){
                    objectToArrray[0].classList.add('owl-carousel__nav-active');
        
                    let getOwlNav = document.querySelectorAll('.owl-carousel__nav-active .owl-nav button');
        
                    let createImageLeft = document.createElement('img');
                    let createImageRight = document.createElement('img');
        
                    createImageLeft.classList.add('owl-carousel__nav-active__left');
                    createImageRight.classList.add('owl-carousel__nav-active__right');
        
                    createImageLeft.setAttribute('src', imgL);
                    createImageRight.setAttribute('src', imgR);
        
                    getOwlNav[0].append(createImageLeft);
                    getOwlNav[1].append(createImageRight);
                }
        
                
                dots == true ? objectToArrray[0].classList.add('owl-carousel__dots-active') : ()=>{return false};
        
            }

            var getOwlCarouselOneitems = $(".owl-carousel.owl-carousel__one-items");
            var getValidationCarousel = document.querySelector('.owl-carousel.owl-carousel__one-items');
            if(getValidationCarousel){
                carouselReuse(
                    getOwlCarouselOneitems, //CLASE
                    undefined, //ITEMS
                    false, //LOOP
                    false, //MARGIN
                    true, //NAV
                    undefined, //IMG LEFT
                    undefined, //IMG RIGHT
                    false, //AUTOPLAY
                    0, //AUTOPLAY SECONDS
                    false, //DOTS
                    1, //ITEMS MOBILE
                    1, //ITEMS IPAD SMALL
                    1, //ITEMS IPAD BIG
                    1, //ITEMS DESKTOP
                );
            }

            var getOwlCarouselTab = $(".owl-carousel.owl-carousel__tab");
            var getValidationCarouselTab = document.querySelector('.owl-carousel.owl-carousel__tab');
            if(getValidationCarouselTab){
                carouselReuse(
                    getOwlCarouselTab, //CLASE
                    undefined, //ITEMS
                    true, //LOOP
                    false, //MARGIN
                    true, //NAV
                    "/static/img-estatica/svg/left__tab.svg", //IMG LEFT
                    "/static/img-estatica/svg/right__tab.svg", //IMG RIGHT
                    false, //AUTOPLAY
                    0, //AUTOPLAY SECONDS
                    false, //DOTS
                    1, //ITEMS MOBILE
                    1, //ITEMS IPAD SMALL
                    1, //ITEMS IPAD BIG
                    1, //ITEMS DESKTOP
                );
            }
            
    }

    function _animationCarousel(){

        let getOwlCarouselPrev = document.querySelector('.owl-carousel__banner .owl-prev');
        
        if(getOwlCarouselPrev){
            let getOwlCarouselNext = document.querySelector('.owl-carousel__banner .owl-next');
            let getOwlCaouselParent = document.querySelector('.owl-carousel__banner');
            let getOwlBannerElements = document.querySelectorAll('.banner-custom--no-fixed');
    
            getOwlBannerElements[0].classList.add('active');
    
            getOwlCarouselPrev.addEventListener('click', removeClass);
            getOwlCarouselNext.addEventListener('click', removeClass);
    
    
            function removeClass(){
                getOwlCaouselParent.classList.remove('active');
            }
        }

    }

    return {
        setHandleEvent: function(){
            try{
                _carousel()
            }catch(error){}
            try{
                _animationCarousel()
            }catch(error){}
        }
    }

})();


const loadCarouselHandlers = ()=>{
    carousel.setHandleEvent()
}

export{
    loadCarouselHandlers
}